var map = {
	"./Bronze.svg": 887,
	"./Diamond.svg": 888,
	"./Gold.svg": 889,
	"./Silver.svg": 890,
	"./company-default.png": 157,
	"./dummy.jpg": 217,
	"./dummy_profile.jpg": 115,
	"./icons8-whatsapp.svg": 85,
	"./invoice-sign": 258,
	"./invoice-sign.js": 258,
	"./videoimg.png": 271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;